import { IonButton, IonButtons, IonIcon } from '@ionic/react'
import { chatboxOutline, chevronBackOutline } from 'ionicons/icons'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './AssessmentNarratives.component.css'
import { useDispatch, useSelector } from 'react-redux'
import { BodyAssessmentConstants } from '../store/bodyAssessment.constants'
import { getObstetricsSelector } from '../obstetrics/selectors'
import { getDrainsAndTubesSelector } from '../drainsTubes/selectors'
import { saveObstetrics, setComments as setObstetricsComments } from '../obstetrics/store/obstetrics.actions'
import { saveDrainsTubes, setComments as setDrainsAndTubesComments } from '../drainsTubes/store/drainsAndTubes.actions'
import { getBodyAssessmentSelector } from '../selectors'
import TextArea from '../../../../components/textArea/TextArea.component'
import { setFindingsComments } from '../bodySurvey/store/bodySurvey.actions'
export interface IAssessmentNarrativesProps {
  hideBackBtn?: boolean
  handleBackClick?: (() => void) | null
  comments?: string
  hideComments?: boolean
  disabled?: boolean
}
const AssessmentNarrativesComponent: React.FC<IAssessmentNarrativesProps> = (props: IAssessmentNarrativesProps) => {
  const { hideBackBtn = false, handleBackClick = null, comments = '', hideComments, disabled } = props
  const [displayComments, setDisplayComments] = useState(hideComments)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const obstetrics = useSelector(getObstetricsSelector)
  const { comments: obstetricsComment } = obstetrics
  const drainsAndTubes = useSelector(getDrainsAndTubesSelector)
  const { comments: drainsAndTubesComment } = drainsAndTubes
  const { selectedExam } = useSelector(getBodyAssessmentSelector)

  const getCommentsState = (exam: string) => {
    switch (exam) {
      case BodyAssessmentConstants.OBSTETRICS:
        return {
          value: obstetricsComment,
          action: setObstetricsComments,
          saveAction: saveObstetrics,
          maxLength: 4000,
        }
      case BodyAssessmentConstants.DRAINS_TUBES:
        return {
          value: drainsAndTubesComment,
          action: setDrainsAndTubesComments,
          saveAction: saveDrainsTubes,
          maxLength: 250,
        }
      case BodyAssessmentConstants.BODY_SURVEY:
      case BodyAssessmentConstants.NEURO_CONDITIONS:
      case BodyAssessmentConstants.MENTAL_CONDITIONS:
      case BodyAssessmentConstants.CARDIO_CONDITIONS:
        return {
          value: comments,
          action: setFindingsComments,
          saveAction: null,
          maxLength: 4000,
        }
      default:
        return {
          value: '',
          action: () => null,
          saveAction: () => null,
          maxLength: 500,
        }
    }
  }
  const commentsState = getCommentsState(selectedExam)
  const onBackClick = () => {
    if (handleBackClick) handleBackClick()
  }

  const handleOnChange = (commentText: string | null | undefined) => {
    setDisplayComments(false)
    if (commentText === comments) return
    if (commentsState?.action) {
      dispatch(commentsState?.action(commentText))
    }
    if (commentsState?.saveAction) {
      dispatch(commentsState?.saveAction())
    }
  }

  return (
    <div id='assessment-narratives-section'>
      <div className='assessments-comments-section'>
        <h6>
          <span className='ion-flex ion-align-items-center'>
            <IonIcon size='large' icon={chatboxOutline} className='mr-10' /> Comments
          </span>
          {!hideBackBtn && (
            <IonButtons slot='start'>
              <IonButton color='primary' data-testid='BackButton' onClick={onBackClick} className='back-btn'>
                <IonIcon icon={chevronBackOutline} />
                {t('common.buttons.Back')}
              </IonButton>
            </IonButtons>
          )}
        </h6>
        <div className={disabled ? 'narratives-area disabled-text' : 'narratives-area'}>
          <TextArea
            dataTestID={t('bodyAssessment.NarrativesSection')}
            value={!displayComments ? commentsState.value : ''}
            onChangeAction={(e) => handleOnChange(e.detail.value)}
            maxlength={commentsState.maxLength}
            rows={10}
            validationId={t('bodyAssessment.NarrativesSection')}
            label={''}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}
export default AssessmentNarrativesComponent
